import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { Country } from '@/common/types/work-info.def.ts'

export const BankAccountPurpose = {
  Custom: 'Custom',
  Payroll: 'Payroll',
}
export const BankAccountPurposeOptions = stringArrayToSelectOptions(Object.values(BankAccountPurpose))

export const SalaryType = {
  Monthly: 'Monthly',
  Annual: 'Annual',
  Hourly: 'Hourly',
}
export const SalaryTypeOptions = stringArrayToSelectOptions(Object.values(SalaryType))

export const SalaryUpdateReason = {
  NewHire: 'New Hire',
  MidYearAppraisal: 'Mid-Year Appraisal',
  AnnualAppraisal: 'Annual Appraisal',
  PromotionAdjustment: 'Promotion Adjustment',
  MarketAdjustment: 'Market Adjustment',
}
export const SalaryUpdateReasonOptions = stringArrayToSelectOptions(Object.values(SalaryUpdateReason))

export const Currency = {
  USD: 'USD',
  HKD: 'HKD',
  CNY: 'CNY',
  SGD: 'SGD',
  JPY: 'JPY',
  KRW: 'KRW',
  AUD: 'AUD',
  TWD: 'TWD',
  GBP: 'GBP',
  INR: 'INR',
}
export const CurrencyOptions = stringArrayToSelectOptions(Object.values(Currency))

export const CountryCurrencyMap = {
  [Country.UnitedStates]: 'USD',
  [Country.HongKong]: 'HKD',
  [Country.China]: 'CNY',
  [Country.Singapore]: 'SGD',
  [Country.Japan]: 'JPY',
  [Country.Korea]: 'KRW',
  [Country.Australia]: 'AUD',
  [Country.Taiwan]: 'TWD',
  [Country.UnitedKingdom]: 'GBP',
  [Country.India]: 'INR',
}

export const BonusType = {
  Custom: 'Custom',
  DiscretionaryBonus: 'Discretionary Bonus',
  PerformanceBonus: 'Performance Bonus',
  SigningBonus: 'Signing Bonus',
  GuaranteedBonus: 'Guaranteed Bonus',
  MinimumGuaranteedBonus: 'Minimum Guaranteed Bonus',
  AdditionalBonus: 'Additional Bonus',
  CompletionBonus: 'Completion Bonus',
  RetentionBonus: 'Retention Bonus',
  DeploymentBonus: 'Deployment Bonus',
  TipsFromPM: 'Tips From PM',
  ReferralBonus: 'Referral Bonus',
  SpecialBonus: 'Special Bonus',
  SeniorManagementIncentiveProgram: 'Senior Management Incentive Program',
}
export const BonusTypeOptions = stringArrayToSelectOptions(Object.values(BonusType))

